var FileResult = /** @class */ (function () {
    function FileResult(_fileURL, _fileFullPath) {
        this._fileURL = _fileURL;
        this._fileFullPath = _fileFullPath;
    }
    Object.defineProperty(FileResult.prototype, "fileURL", {
        get: function () {
            return this._fileURL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileResult.prototype, "fileFullPath", {
        get: function () {
            return this._fileFullPath;
        },
        enumerable: true,
        configurable: true
    });
    return FileResult;
}());
export { FileResult };



//////////////////
// WEBPACK FOOTER
// ./src/models/files/fileResult.ts
// module id = 641
// module chunks = 50